import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import { ModalCloseIcon } from 'ctm-components';
import { resultsConfigSelector } from 'ctm-selectors';
import { connect } from 'react-redux';
import { logMessage } from 'ctm-util-functions';
import EstimatedRebuildCostInfo from './info_content_estimated_rebuild_cost';
import EstimatedContentsReplacementCostInfo from './info_content_estimated_contents_replacement_cost';

const theme = createTheme({
    overrides: {
        MuiPaper: {
            root: {
                padding: '2rem',
                overflowY: 'unset !important'
            }
        }
    }
});

/**
 * Info Modal
 * @param {Object} props React props.
 * @returns {InfoModal} The modal
 */
const InfoModal = (props) => {
    const { isOpen, closeModal, infoModalKey } = props;

    React.useEffect(() => {
        if (isOpen && infoModalKey) {
            let label = infoModalKey;
            if (infoModalKey === 'estimatedRebuildCost') {
                label = 'suminsuredEstimatedRebuildCost';
            } else if (infoModalKey === 'estimatedContentReplacementCost') {
                label = 'suminsuredEstimatedReplacementCost';
            }
            if (!window.dataLayer) {
                window.dataLayer = [];
            }
            window.dataLayer.push({
                event: 'INTERACTION_EVENT',
                interaction: {
                    ixn_action: 'Click',
                    ixn_object: 'Link',
                    ixn_type: 'Link',
                    ixn_label: label,
                    ixn_value: infoModalKey
                }
            });

            logMessage('interaction_event pushed to GTM:', infoModalKey);

            setTimeout(() => {
                window.dataLayer.push({
                    event: 'Clear interaction array',
                    interaction: []
                });
            }, 0);
        }
    }, [isOpen, infoModalKey]);

    /**
     * Render top-right modal close icon button
     * @return {Node} the CloseIcon button
     */
    const renderCloseIcon = () => {
        const closeIconProps = { onClickFunction: closeModal };
        return React.createElement(ModalCloseIcon, closeIconProps);
    };

    let content = null;
    switch (infoModalKey) {
        case 'estimatedRebuildCost':
            content = <EstimatedRebuildCostInfo />;
            break;
        case 'estimatedContentReplacementCost':
            content = <EstimatedContentsReplacementCostInfo />;
            break;
        default:
            content = null;
    }

    return (
        <ThemeProvider theme={theme}>
            <Dialog open={isOpen} maxWidth="sm" fullWidth disableEscapeKeyDown>
                {content}
                {renderCloseIcon()}
            </Dialog>
        </ThemeProvider>
    );
};

InfoModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    infoModalKey: PropTypes.string
};

/**
 * mapStateToProps - sets up the rules required by this component
 * @param {Object} state - Redux store state.
 * @param {Object} ownProps - Get the component's own props to determine which info modal state to select.
 * @return {Object} - The state attributes to add to props.
 */
const mapStateToProps = (state, ownProps) => {
    const key = ownProps.infoModalKey || 'estimatedRebuildCost';
    const infoModal = resultsConfigSelector(state).getIn(['helpers', key]);

    return {
        isOpen: infoModal ? infoModal.open : false
    };
};

const ConnectedInfoModal = connect(mapStateToProps)(InfoModal);

export { InfoModal };
export default ConnectedInfoModal;
